import React, { useState, useEffect } from 'react';
import { Container, Typography, Tabs, Tab, Box, CircularProgress } from '@mui/material';
import { Toaster, toast } from 'sonner';
import UserDetailsForm from './UserDetailsForm';
import OrganizationDetailsForm from './OrganizationDetailsForm';
import SecuritySettings from './SecuritySettings';
import NotificationSettings from './NotificationSettings';
import { useSelector } from 'react-redux';

const ProfileSettings = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [organizationData, setOrganizationData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [userIdLoading, setUserIdLoading] = useState(true);

  // Use Redux first, fallback to localStorage
  const userIdFromRedux = useSelector(state => state.onboarding.userId);
  const userId = userIdFromRedux || localStorage.getItem('userId');

  useEffect(() => {
    setUserIdLoading(false);
  }, []);

  useEffect(() => {
    if (userId) {
      fetchOrganizationData();
    }
  }, [userId]);

  const fetchOrganizationData = async () => {
    setIsLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      const simulatedData = {
        name: 'Sample Organization',
        industry: 'Technology',
        size: '100-500 employees',
        website: 'www.sampleorganization.com'
      };
      setOrganizationData(simulatedData);
    } catch (error) {
      console.error('Error fetching organization data:', error);
      toast.error('Failed to load organization data', {
        style: { background: 'red', color: 'white' }
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleOrganizationSubmit = async (formData) => {
    setIsLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setOrganizationData(formData);
      toast.success('Organization details updated successfully', {
        style: { background: 'green', color: 'white' }
      });
    } catch (error) {
      console.error('Error updating organization data:', error);
      toast.error('Failed to update organization details', {
        style: { background: 'red', color: 'white' }
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Typography  mt={3} variant="h4" gutterBottom>Profile Settings</Typography>
      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tab label="User Details" />
        <Tab label="Organization Details" />
        <Tab label="Security" />
        <Tab label="Notifications" />
      </Tabs>
      <Box mt={3}>
        {userIdLoading ? (
          <CircularProgress />
        ) : (
          <>
            {activeTab === 0 && <UserDetailsForm userId={userId} />}
            {activeTab === 1 && (
              <OrganizationDetailsForm
                userId={userId}
                onSubmit={handleOrganizationSubmit}
                initialData={organizationData}
                isLoading={isLoading}
              />
            )}
            {activeTab === 2 && <SecuritySettings />}
            {activeTab === 3 && <NotificationSettings />}
          </>
        )}
      </Box>
      <Toaster
        position="top-right"
        expand={false}
        richColors
        className='mt-24'
        toastOptions={{
          duration: 5000,
          style: {
            borderRadius: '8px',
            padding: '16px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            fontSize: '14px',
            maxWidth: '350px',
          },
        }}
      />
    </Container>
  );
};

export default ProfileSettings;
